import styled from 'styled-components';

import media from 'apps/promo/theme/media';

interface ContainerProps {
    insideModalComponent?: boolean;
}

interface MainTextProps {
    hasBorder?: boolean;
    breakWord?: boolean;
}

const shouldForwardContainerProp = (prop: string) => !['insideModalComponent'].includes(prop);
const shouldForwardMainTextProp = (prop: string) => !['hasBorder', 'breakWord'].includes(prop);

export const Container = styled.div.withConfig({ shouldForwardProp: shouldForwardContainerProp })<ContainerProps>`
    background-color: ${(props) => props.theme.white};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    padding: ${(props) => (props.insideModalComponent ? '0' : '72px 24px 92px 24px')};
`;

export const CenterContainer = styled.div`
    width: 100%;
    max-width: 504px;
`;

export const HeaderText = styled.div`
    font-size: 24px;
    line-height: 36px;
    margin-top: 24px;
    color: ${(props) => props.theme.black};

    span,
    .color-GT {
        color: ${(props) => props.theme.purple_100};
    }

    ${media.desktop1920} {
        font-size: 32px;
        line-height: 48px;
    }
`;
export const SecondaryText = styled.div`
    font-size: 17px;
    line-height: 24px;
    margin-top: 16px;
    color: ${(props) => props.theme.grey_72_lc};

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
    }
`;

export const SecondarySmallText = styled.div`
    font-size: 14px;
    line-height: 20px;
    margin-top: 16px;
    color: ${(props) => props.theme.grey_72_lc};

    ${media.desktop1920} {
        font-size: 17px;
        line-height: 24px;
    }
`;

export const MainText = styled.span.withConfig({ shouldForwardProp: shouldForwardMainTextProp })<MainTextProps>`
    display: inline-block;
    font-size: 17px;
    line-height: 24px;
    margin-top: 24px;
    border-bottom: ${(props) => (props.hasBorder ? '1px solid rgba(159, 157, 163, 0.28)' : null)};
    padding-bottom: ${(props) => (props.hasBorder ? '32px' : null)};
    word-break: ${(props) => (props.breakWord ? 'break-word' : null)};

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
        padding-bottom: ${(props) => (props.hasBorder ? '48px' : null)};
    }
`;

export const RowButtonContainer = styled.div`
    margin-top: 16px;

    ${media.desktop1920} {
        margin-top: 28px;
    }
`;
